import classNames from 'classnames';
import React from 'react';
import { Img } from 'react-image';
import { useThemeContext } from 'src/context/ThemeProvider';

const HowLevelUpWorksCard = () => {
	const { themeMode } = useThemeContext();
	const data = [
		{
			img: '/assets/refer/one.svg',
			lightImg: '/assets/refer/one-light.svg',
			title: 'Give FREE technical round',
			subTitle: 'Simulate real interviews with industry pros to gauge tech skills.',
		},
		{
			img: '/assets/refer/two.svg',
			lightImg: '/assets/refer/two-light.svg',
			title: 'Attain your Level',
			subTitle: 'Level is based on your technical round, showcasing your expertise.',
		},
		{
			img: '/assets/refer/three.svg',
			lightImg: '/assets/refer/three-light.svg',
			title: 'Get shortlisted',
			subTitle: 'Skip the waiting and get connected with recruiters.',
		},
	];
	return (
		<div
			className={classNames(`flex flex-col gap-6 px-5 py-7 rounded-md`, {
				'how-levelup-work-card': themeMode === 'dark',
				'how-levelup-work-card-light': themeMode === 'light',
			})}
		>
			<div className="text-2xl font-bold blue-gradient-text">How LevelUp works?</div>
			<div className="flex flex-col gap-4">
				{data.map(d => (
					<div className="flex gap-2 justify-start items-center">
						{themeMode === 'dark' ? (
							<Img loading="lazy" src={d.img} alt="" width={64} height={64} />
						) : (
							<Img loading="lazy" src={d.lightImg} alt="" width={'64px'} height={'64px'} />
						)}

						<div>
							<div className=" text-xl font-medium dark:text-white text-[#28293D]">{d.title}</div>
							<div className="">
								<div className=" text-base font-normal dark:text-[#C7C9D9] text-[#555770]">{d.subTitle}</div>
							</div>
						</div>
					</div>
				))}
				<div></div>
			</div>
		</div>
	);
};

export default HowLevelUpWorksCard;
